// src/firebase.js
const firebase = require('firebase/app');
require('firebase/database');

const config = {
    apiKey: "AIzaSyBPRr6Ei-8FFhVEdLVyBYrL4kuJH_xWjo0",
    authDomain: "smoy-metsatesti.firebaseapp.com",
    databaseURL: "https://smoy-metsatesti.firebaseio.com",
    projectId: "smoy-metsatesti",
    storageBucket: "smoy-metsatesti.appspot.com",
    messagingSenderId: "571984519649"
  };

firebase.initializeApp(config);
export default firebase;
